import type { Theme } from '@mui/material/styles';

const aboveMuiModal = (offset: number) => {
  return (theme: Theme) => theme.zIndex.modal + offset;
};

export const appZIndex = {
  base: 1,
  raised: 2,
  floating: 5,
  sticky: 10,
  prioritySticky: 50,

  // MUI modal is normally 1300.
  // Keep module drawer above normal modal/popover/map layers.
  drawer: aboveMuiModal(1),

  // Menus / poppers that open from inside the module drawer.
  drawerPopup: aboveMuiModal(2),
};
